<template>
  <div class="quiz-result">
    <div class="content columns">
      <div class="title-col column col-12">
        <div class="title title-col__title desktop-hidden">
          <span class="title-col__text">
            Kreatywna drużynowa
          </span>
        </div>
      </div>
      <div class="images-col column col-4 col-sm-12">
        <div class="thumbnail">
          <img :src="require('@/assets/images/pic-s1-kreatywna-druzynowa.png')"
               alt="Segment" class=" img-responsive thumbnail-image" />
        </div>
      </div>
      <div class="description column">
        <div class="title title-col__title mobile-hidden">
          <span class="title-col__text">
            Kreatywna drużynowa
          </span>
        </div>
        <div class="description__content">
          <p class="quote">
            "Razem tworzymy magię"
          </p>
          <p>
            Uwielbiasz działać z ludźmi – nie tylko dla efektów,
            ale dla samej radości wspólnego tworzenia.
            Potrafisz ożywić każde spotkanie, zebrać znajomych wokół wspólnego celu i sprawić,
            że nawet najnudniejszy projekt nabiera barw.
            Energia, którą wnosisz, jest zaraźliwa – i to dzięki niej inni chcą działać.
          </p>
          <p>
            Nie potrzebujesz dowodzić ani dominować – Ty łączysz.
            Tworzysz atmosferę, w której każda osoba czuje się potrzebna.
            W pracy lub w życiu prywatnym – jesteś tą, która organizuje, inspiruje i zachęca.
            Masz naturalny talent do tworzenia „paczki” wokół siebie.
          </p>
          <p>
            W relacjach jesteś sercem zespołu. Twoje słowa budują, Twoje pomysły porywają.
            Ludzie czują się przy Tobie zauważeni – i to jest prawdziwy dar.
          </p>
          <p>
            Twoja supermoc? Tworzysz z innych drużynę – i robisz to z uśmiechem,
            bez presji, z lekkością.
          </p>
          <p>
            <strong>Twoje wartości:</strong> współpraca, radość, spontaniczność<br/>
            <strong>Styl życia:</strong> dynamiczny, towarzyski, pełen ludzi i pomysłów<br/>
            <strong>W relacjach:</strong> ciepła, integrująca, tworzysz „stado”<br/>
            <strong>Supermoc:</strong> budujesz zespoły i ożywiasz wspólne działania
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KreatywnaDruzynowa',
};
</script>

<style scoped>
.title-col__text {
  color: var(--color-kreatywna) !important;
}
.thumbnail-image {
  border-radius: 900px;
}
.quiz-result .percentage__value {
  color: var(--color-kreatywna);
}
.quiz-result .quote {
  font-style: italic;
  font-weight: 600;
  font-size: 22px;
}
</style>
